export default __webpack_public_path__ + "static/media/showShopIcon.a969304c.svg";